export function formatCurrency(value: number) {
  return new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: "KES",
    maximumFractionDigits: 0
  }).format(value);
}

export function formatDateTime(value?: string | null) {
  if (!value) {
    return "Unknown";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("en-KE", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(date);
}

export function cx(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

export function parseTestedWith(value?: string | null) {
  if (!value) return [];

  return Array.from(
    new Set(
      value
        .split(",")
        .map((item) => item.replace(/\*/g, "").trim())
        .filter(Boolean)
    )
  ).slice(0, 4);
}

export function toSentenceCase(value: string) {
  const normalized = value.trim().toLocaleLowerCase();

  if (!normalized) {
    return "";
  }

  return normalized.charAt(0).toLocaleUpperCase() + normalized.slice(1);
}

export function toDarkModeImageUrl(value?: string | null) {
  if (!value) {
    return null;
  }

  if (!value.includes("res.cloudinary.com") || !value.includes("/image/upload/")) {
    return value;
  }

  return value.replace(
    "/image/upload/",
    "/image/upload/e_bgremoval:rgb:ffffff/f_png/"
  );
}
